"use client";

import { Component } from "react";
import loadScript from "load-script";
import { StoreContext } from "../../stores/StoreContext";
import { getConfig } from "../../_configs/AppConfig";
import { AppContextType } from "../../stores/StoreLoader";
const { publicRuntimeConfig } = getConfig();

export class MeritChat<P = {}, S = {}> extends Component<P, S> {
  static contextType = StoreContext;

  loginFunction = (): void => {
    const { modalStore } = this.context as AppContextType;
    modalStore.addModal({
      type: "login",
      size: "lg",
      id: "login-modal",
    });
  };

  onLoaded = () => {
    const { organizationStore } = this.context as AppContextType;
    if (typeof MC !== "undefined") {
      MC.hostname = publicRuntimeConfig.MERITCHAT_API_URL.replace(
        "https://",
        "",
      );
      MC.reactInit(
        organizationStore.currentOrganization.mcauth,
        this.loginFunction,
      );
    }
  };

  componentDidMount() {
    if (typeof MC === "undefined") {
      loadScript(
        `${publicRuntimeConfig.MERITCHAT_API_URL}/meritchat.js`,
        this.onLoaded,
      );
    }
  }
}

export class MeritChatThread extends MeritChat<
  {
    source_id: number;
    source_category: string;
    organization_id: string;
  },
  any
> {
  render() {
    return (
      <div
        className="meritchat thread"
        data-source-id={this.props.source_id}
        data-organization-id={this.props.organization_id}
        data-source-category={this.props.source_category}
      />
    );
  }
}

export class MeritChatOrgReport extends MeritChat<
  {
    organization_id: string;
  },
  any
> {
  render() {
    return (
      <div
        className="meritchat orgreport"
        data-source-org={this.props.organization_id}
      />
    );
  }
}

export class MeritChatModeratorMenu extends MeritChat {
  render() {
    return <div className="meritchat moderator single" />;
  }
}
export class MeritChatThreadCTA extends MeritChat<{}, any> {
  render() {
    return (
      <span
        className="meritchat thread-cta"
        data-source-id="1"
        data-source-category="custom.news"
      ></span>
    );
  }
}
